export default function createUnresolveablePromise() {
  return new Promise(() => {})
}
